module.exports = __webpack_public_path__ + "img/bag.b469c6a0.svg";